import { gql } from '@apollo/client';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LOGIN_PATH } from 'src/common/constants';
import {
  ErrorMstRelation,
  MstContractPeriod,
  MstHinInfoDisplay,
  MstHinInfor,
  MstHinmei,
  MstProduct,
  MstRelation,
  MutationSet,
  PrimaryStore,
  SecondaryStore,
} from 'src/common/interfaces';
import { DiscountType } from 'src/common/number-enum';
import { RecordState } from 'src/common/string-enum';
import { ErrorMessage, InfoMessage, InfoWord } from 'src/enum/messsage-enum';
import { insertMstHinInfo, updateMstHinInfo } from 'src/graphql/mutations';
import {
  getMstContractPeriod,
  getMstHinInfo,
  getMstHinmei,
  getMstPrimarySales,
  getMstProduct,
  getMstSecondarySales,
} from 'src/graphql/queries';
import { useAppLazyQuery, useAppMutation } from 'src/libs/hooks';
import utility from 'src/libs/utility';
import MainLayout from '../main-layout';

const optionsDiscount = [
  { value: 0, label: 'x' },
  { value: 1, label: 'o' },
];
const defaultErrorMstProductName: ErrorMstRelation = {
  isErrorMaintenancePrice: false,
  isErrorOso: false,
  isErrorAddHinmei1: false,
  isErrorAddHinmei2: false,
  isErrorProductPrice: false,
  isErrorDefaultSuryo: false,
};
const HinInfoManage = () => {
  const header = [
    '品名',
    '一次店',
    '二次店',
    '製品区分',
    '契約年数',
    '追加品名１',
    '追加品名２',
    '製品単価',
    '保守単価',
    'OSOコード',
    '初期数量',
    '使用可',
  ];
  const [mstRelation, setMstRelation] = useState<MstHinInfoDisplay | undefined>(undefined);
  const [dataRelationDisplay, setRelationDisplay] = useState<MstHinInfoDisplay | undefined>(undefined);
  const [primarySalesOption, setPrimarySalesOption] = useState<Array<PrimaryStore>>([]);

  // 二次店の選択肢は、一次店の選択状況に応じるため、DBの値と表示用の値の2種類を保持する
  const [secondarySalesOptionRaw, setSecondarySalesOptionRaw] = useState<Array<SecondaryStore>>([]);
  const [secondarySalesOption, setSecondarySalesOption] = useState<Array<SecondaryStore>>([]);
  const [productOption, setProductOption] = useState<Array<MstProduct>>([]);
  const [contractPeriodOption, setContractPeriodOption] = useState<Array<MstContractPeriod>>([]);
  const [selectPrimarySales, setSelectPrimarySales] = useState('');
  const [selectSecondarySales, setSelectSecondarySales] = useState('');
  const [selectProduct, setSelectProduct] = useState('');
  const [selectContractPeriod, setSelectContractPeriod] = useState('');
  const { confirmAlert, showAlertMessage, registerData } = utility;
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut } = useAuthenticator((context) => [context.user]);
  const [updateFunc] = useAppMutation({ query: gql(updateMstHinInfo) });
  const [insertFunc] = useAppMutation({ query: gql(insertMstHinInfo) });
  const [searchMstPrimarySales, { loading: isPStoreLoading }] = useAppLazyQuery({ query: gql(getMstPrimarySales) });
  const [searchMstSecondarySales, { loading: isSStoreLoading }] = useAppLazyQuery({
    query: gql(getMstSecondarySales),
  });
  const [searchMstProduct, { loading: isProductLoading }] = useAppLazyQuery({ query: gql(getMstProduct) });
  const [searchMstHinmei, { loading: isHinmeiLoading }] = useAppLazyQuery({ query: gql(getMstHinmei) });
  const [searchMstHinInfor, { loading: isHinInfoLoading }] = useAppLazyQuery({ query: gql(getMstHinInfo) });
  const [searchMstContractPeriod, { loading: isContractPeriodLoading }] = useAppLazyQuery({
    query: gql(getMstContractPeriod),
  });

  const betweenNumber = (val: number, min: number, max: number) => {
    return val >= min && val <= max;
  };

  const renderTableData = useMemo(() => {
    if (!dataRelationDisplay) return;
    const dispData = { ...dataRelationDisplay };
    const styleInput = (isError: boolean | undefined) => {
      return `${isError ? 'border-[#FF0000] border-[2px] rounded-md' : 'border-{transparent}'} bg-transparent py-[5px]`;
    };

    return Object.entries(dispData).map(([key, value]) => {
      return (
        <tr className="hover:opacity-80 odd:bg-[#e2efd9]" key={key}>
          <td className="border-[1px] border-solid border-[#fff]">
            <p className="bg-transparent py-[5px]">{value.mh_hin_nm ?? ''}</p>
          </td>
          <td className="border-[1px] border-solid border-[#fff]">
            <p className="bg-transparent py-[5px] ">{value.mps_primary_nm ?? ''}</p>
          </td>
          <td className=" border-[1px] border-solid border-[#fff]">
            <p className="bg-transparent py-[5px] ">{value.mss_secondary_nm ?? ''}</p>
          </td>
          <td className="border-[1px] border-solid border-[#fff]">
            <p className="bg-transparent py-[5px] ">{value.mpr_product_nm ?? ''}</p>
          </td>
          <td className="border-[1px] border-solid border-[#fff]">
            <p className="bg-transparent py-[5px] ">{value.mhi_years ?? ''}</p>
          </td>
          <td className=" border-[1px] border-solid border-[#fff]">
            <input
              className={styleInput(value.error?.isErrorAddHinmei1)}
              onChange={(event) => {
                if (!betweenNumber(Number(event?.target?.value?.length), 0, 50)) return;
                handleChangeValue(key, {
                  ...value,
                  ...{ mhi_add_hinmei1: event.target.value },
                  ...{ error: { ...value.error, ...{ isErrorAddHinmei1: false } } },
                });
              }}
              type="text"
              name="mhi_add_hinmei1"
              value={value.mhi_add_hinmei1 ?? ''}
            />
          </td>
          <td className="border-[1px] border-solid border-[#fff] ">
            <input
              className={styleInput(value.error?.isErrorAddHinmei2)}
              onChange={(event) => {
                if (!betweenNumber(Number(event?.target?.value?.length), 0, 50)) return;
                handleChangeValue(key, {
                  ...value,
                  ...{ mhi_add_hinmei2: event.target.value },
                  ...{ error: { ...value.error, ...{ isErrorAddHinmei2: false } } },
                });
              }}
              type="text"
              name="mhi_add_hinmei2"
              value={value.mhi_add_hinmei2 ?? ''}
            />
          </td>
          <td className=" border-[1px] border-solid border-[#fff]">
            <input
              className={styleInput(value.error?.isErrorProductPrice)}
              onChange={(event) => {
                if (!betweenNumber(Number(event?.target?.value?.length), 1, 11)) return;
                handleChangeValue(key, {
                  ...value,
                  ...{ mhi_product_price: Number(event.target.value) },
                  ...{ error: { ...value.error, ...{ isErrorProductPrice: false } } },
                });
              }}
              type="number"
              name="mhi_product_price"
              min={0}
              value={value.mhi_product_price ?? ''}
            />
          </td>
          <td className=" border-[1px] border-solid border-[#fff] ">
            <input
              className={styleInput(value.error?.isErrorMaintenancePrice)}
              onChange={(event) => {
                if (!betweenNumber(Number(event?.target?.value?.length), 1, 11)) return;
                handleChangeValue(key, {
                  ...value,
                  ...{ mhi_maintenance_price: event.target.value },
                  ...{ error: { ...value.error, ...{ isErrorMaintenancePrice: false } } },
                });
              }}
              type="number"
              name="mhi_maintenance_price"
              min={0}
              value={value.mhi_maintenance_price ?? ''}
            />
          </td>
          <td className="border-[1px] border-solid border-[#fff] ">
            <input
              className={styleInput(value.error?.isErrorOso)}
              onChange={(event) => {
                if (!betweenNumber(Number(event?.target?.value?.length), 0, 50)) return;
                handleChangeValue(key, {
                  ...value,
                  ...{ mhi_oso_cd: event.target.value },
                  ...{ error: { ...value.error, ...{ isErrorOso: false } } },
                });
              }}
              type="text"
              name="mhi_oso_cd"
              value={value.mhi_oso_cd ?? ''}
            />
          </td>
          <td className=" border-[1px] border-solid border-[#fff] ">
            <input
              className={styleInput(value.error?.isErrorDefaultSuryo)}
              onChange={(event) => {
                if (!betweenNumber(Number(event?.target?.value?.length), 1, 11)) return;
                handleChangeValue(key, {
                  ...value,
                  ...{ mhi_default_suryo: Number(event.target.value) },
                  ...{ error: { ...value.error, ...{ isErrorDefaultSuryo: false } } },
                });
              }}
              type="number"
              name="mhi_default_suryo"
              min={0}
              value={value.mhi_default_suryo ?? ''}
            />
          </td>
          <td className="border-[1px] border-solid border-[#fff] ">
            <select
              className={styleInput(false)}
              name="mhi_available_kb"
              onChange={(event) => handleChangeValue(key, { ...value, ...{ mhi_available_kb: event.target.value } })}
              value={value.mhi_available_kb ?? ''}
            >
              {optionsDiscount?.map((itemOption) => {
                return (
                  <option key={`${itemOption?.value}`} value={`${itemOption?.value}`}>
                    {itemOption?.label}
                  </option>
                );
              })}
            </select>
          </td>
        </tr>
      );
    });
  }, [dataRelationDisplay]);

  const handleChangeValue = (key: string, value: MstRelation) => {
    const targetValue = { ...value, ...{ recordState: value.isBeginData ? RecordState.UPDATE : RecordState.INSERT } };
    setMstRelation((prev) => {
      return { ...prev, ...{ [key]: targetValue } };
    });
    setRelationDisplay((prev) => {
      return { ...prev, ...{ [key]: targetValue } };
    });
  };

  const setRalationDisplayWithSort = (data: MstHinInfoDisplay) => {
    const sortResult = Object.fromEntries(
      Object.entries(data).sort(
        ([, a], [, b]) =>
          Number(a.mhi_hin_cd) - Number(b.mhi_hin_cd) ||
          Number(a.mhi_primary_cd) - Number(b.mhi_primary_cd) ||
          Number(a.mhi_secondary_cd) - Number(b.mhi_secondary_cd) ||
          Number(a.mhi_product_cd) - Number(b.mhi_product_cd)
      )
    );

    setRelationDisplay(sortResult);
  };

  const renderTableHeader = () => {
    return header.map((key, index) => (
      <th
        className="border-[1px] border-solid border-[#fff] pt-[12px] pb-[12px] text-center bg-[#a8d08d] text-[#fff] "
        key={index}
      >
        {key.toUpperCase()}
      </th>
    ));
  };

  const onPressConfirmDisplay = () => {
    Auth.currentAuthenticatedUser()
      .then(() => onDisplayData())
      .catch(() => {
        signOut();
        navigate(LOGIN_PATH, { replace: true, state: { from: location } });
      });
  };

  const onPressConfirmRegister = () => {
    Auth.currentAuthenticatedUser()
      .then(() => {
        confirmAlert(InfoMessage.CONFIRM_REGISTR, '', InfoWord.WARNING, InfoWord.YES, InfoWord.NO, onRegisterData);
      })
      .catch(() => {
        signOut();
        navigate(LOGIN_PATH, { replace: true, state: { from: location } });
      });
  };

  const renderPullDown = useMemo(() => {
    return (
      <div className="flex flex-row mt-[20px] mb-[50px]">
        <div className="border-[#000000] border-[1px] h-[50px] flex flex-row justify-center items-center">
          <div className="p-[8px] text-center bg-[#6699ff90] text-[#fff] h-full justify-center items-center flex">
            <p>一次店</p>
          </div>
          <select
            className="h-full w-[150px]"
            value={selectPrimarySales}
            onChange={(e) => {
              setSelectPrimarySales(e.target.value);
              // 一次店を選択しなおすので、二次店の選択状態と選択しを初期化する
              setSelectSecondarySales('');

              setSecondarySalesOption(
                secondarySalesOptionRaw.filter((item) => item.mss_primary_cd.toString() === e.target.value)
              );
            }}
          >
            <option value={undefined} key={undefined}>
              {''}
            </option>
            {primarySalesOption.map((primarySales: PrimaryStore) => (
              <option value={primarySales?.mps_primary_cd} key={primarySales?.mps_primary_cd}>
                {primarySales?.mps_primary_nm}
              </option>
            ))}
          </select>
        </div>
        <div
          className="border-[#000000] border-[1px] h-[50px] flex flex-row justify-center items-center ml-[50px]"
          onClick={() => {
            if (selectPrimarySales === '') {
              showAlertMessage('', InfoMessage.SELECT_PRIMARY_STORE, InfoWord.ERROR, InfoWord.OK);
            }
          }}
        >
          <div className="p-[8px] text-center bg-[#6699ff90] text-[#fff] h-full justify-center items-center flex">
            <p>二次店</p>
          </div>
          <select
            className="h-full w-[150px]"
            value={selectSecondarySales}
            onChange={(e) => {
              setSelectSecondarySales(e?.target?.value);
            }}
            disabled={selectPrimarySales === '' ? true : false}
          >
            <option value={undefined} key={undefined}>
              {''}
            </option>
            {secondarySalesOption?.map((secondarySales: SecondaryStore) => (
              <option value={secondarySales?.mss_secondary_cd} key={secondarySales?.mss_secondary_cd}>
                {secondarySales?.mss_secondary_nm}
              </option>
            ))}
          </select>
        </div>
        <div className="border-[#000000] border-[1px] h-[50px] flex flex-row justify-center items-center ml-[50px]">
          <div className="p-[8px] text-center bg-[#6699ff90] text-[#fff] h-full justify-center items-center flex">
            <p>製品区分</p>
          </div>
          <select
            className="h-full w-[150px]"
            value={selectProduct}
            onChange={(e) => {
              setSelectProduct(e?.target?.value);
            }}
          >
            <option value={undefined} key={undefined}>
              {''}
            </option>
            {productOption.map((product: MstProduct) => (
              <option value={product?.mpr_product_cd} key={product?.mpr_product_cd}>
                {product?.mpr_product_nm}
              </option>
            ))}
          </select>
        </div>
        <div className="border-[#000000] border-[1px] h-[50px] flex flex-row justify-center items-center ml-[50px]">
          <div className="p-[8px] text-center bg-[#6699ff90] text-[#fff] h-full justify-center items-center flex">
            <p>契約年数</p>
          </div>
          <select
            className="h-full w-[150px]"
            value={selectContractPeriod}
            onChange={(e) => {
              setSelectContractPeriod(e?.target?.value);
            }}
          >
            <option value={undefined} key={undefined}>
              {''}
            </option>
            {contractPeriodOption.map((contractPeriod: MstContractPeriod) => (
              <option value={contractPeriod?.mcp_years} key={contractPeriod?.mcp_years}>
                {contractPeriod?.mcp_years}
              </option>
            ))}
          </select>
        </div>
        <button
          onClick={onPressConfirmDisplay}
          className="border-[#000000] border-[1px] text-center h-[50px] w-[100px] ml-[50px]"
        >
          <b>表示</b>
        </button>
      </div>
    );
  }, [
    primarySalesOption,
    secondarySalesOptionRaw,
    productOption,
    contractPeriodOption,
    selectPrimarySales,
    selectSecondarySales,
    selectContractPeriod,
  ]);

  const prepareDataApplyApi = (productNameData: MstRelation) => {
    return {
      mhi_add_hinmei1: productNameData?.mhi_add_hinmei1,
      mhi_add_hinmei2: productNameData?.mhi_add_hinmei2,
      mhi_available_kb: productNameData?.mhi_available_kb,
      mhi_hin_cd: productNameData?.mhi_hin_cd,
      mhi_maintenance_price: productNameData?.mhi_maintenance_price,
      mhi_oso_cd: productNameData?.mhi_oso_cd,
      mhi_primary_cd: productNameData?.mhi_primary_cd,
      mhi_product_cd: productNameData?.mhi_product_cd,
      mhi_product_price: productNameData?.mhi_product_price,
      mhi_secondary_cd: productNameData?.mhi_secondary_cd,
      mhi_years: productNameData?.mhi_years,
      mhi_default_suryo: productNameData?.mhi_default_suryo,
    };
  };

  const validates = () => {
    let isSuccess = true;
    const newListRelation = { ...mstRelation };

    for (const [key, value] of Object.entries({ ...mstRelation })) {
      if (value.recordState === RecordState.NONE) continue;
      const errorObj = checkError(value);
      if (
        !errorObj.isErrorAddHinmei1 &&
        !errorObj.isErrorAddHinmei1 &&
        !errorObj.isErrorAddHinmei2 &&
        !errorObj.isErrorProductPrice &&
        !errorObj.isErrorMaintenancePrice &&
        !errorObj.isErrorOso &&
        !errorObj.isErrorDefaultSuryo
      )
        continue;

      // Errorが存在する場合はObjectを格納
      newListRelation[key] = { ...value, ...{ error: errorObj } };
      isSuccess = false;
    }

    if (!isSuccess) {
      setRelationDisplay(newListRelation);
      showAlertMessage('', ErrorMessage.INPUT_ERROR, 'error', 'Ok');
    }
    return isSuccess;
  };

  const onDisplayData = async () => {
    if (selectPrimarySales === '' || selectSecondarySales === '' || selectProduct === '') {
      return;
    }

    // 明細部の条件を取得
    const initDataList = await Promise.all([
      searchMstPrimarySales({ variables: { input: { mps_primary_cd: selectPrimarySales } } }),
      searchMstSecondarySales({
        variables: { input: { mss_primary_cd: selectPrimarySales, mss_secondary_cd: selectSecondarySales } },
      }),
      searchMstHinmei({ variables: { input: {} } }),
      searchMstHinInfor({
        variables: { input: { mhi_primary_cd: selectPrimarySales, mhi_secondary_cd: selectSecondarySales } },
      }),
      searchMstProduct({ variables: { input: { mpr_product_cd: selectProduct } } }),
      searchMstContractPeriod({ variables: { input: { mcp_years: selectContractPeriod } } }),
    ]);

    const primarySales = initDataList[0].data.getMstPrimarySales;
    const secondarySales = initDataList[1].data.getMstSecondarySales;
    const hinmei = initDataList[2].data.getMstHinmei;
    const hinInfo = initDataList[3].data.getMstHinInfo;
    const product = initDataList[4].data.getMstProduct;
    const contractPeriod = initDataList[5].data.getMstContractPeriod;

    initTableData({
      mstHinmei: hinmei,
      mstPrimarySales: primarySales,
      mstSecondarySales: secondarySales,
      mstProduct: product,
      mstHinInfo: hinInfo,
      mstContractPeriod: contractPeriod,
    });
  };

  const onRegisterData = async () => {
    const mstRelationNewList = { ...mstRelation };
    const values = Object.values(mstRelationNewList);
    const updateData = values.filter((item: MstRelation) => item?.recordState === RecordState.UPDATE);
    const insertData = values.filter((item: MstRelation) => item?.recordState === RecordState.INSERT);

    const insSet: MutationSet<MstRelation> = {
      recordState: RecordState.INSERT,
      data: insertData,
      func: (data: MstRelation) => insertFunc({ variables: { input: prepareDataApplyApi(data) } }),
    };

    const updSet: MutationSet<MstRelation> = {
      recordState: RecordState.UPDATE,
      data: updateData,
      func: (data: MstRelation) => updateFunc({ variables: { input: prepareDataApplyApi(data) } }),
    };

    const searchFunc = async () => {
      await loadInitData();
    };

    registerData<MstRelation>({
      mutationSets1: [updSet, insSet],
      validates,
      searchFunc,
    });

    return;
  };

  const checkError = (itemRelation: MstRelation) => {
    const isErrorAddHinmei1 = !betweenNumber(Number(itemRelation?.mhi_add_hinmei1?.toString()?.length ?? 0), 0, 50);
    const isErrorAddHinmei2 = !betweenNumber(Number(itemRelation?.mhi_add_hinmei2?.toString()?.length ?? 0), 0, 50);
    const isErrorProductPrice = !betweenNumber(Number(itemRelation?.mhi_product_price?.toString()?.length ?? 0), 0, 11);
    const isErrorMaintenancePrice = !betweenNumber(
      Number(itemRelation?.mhi_maintenance_price?.toString()?.length ?? 0),
      0,
      11
    );
    const isErrorOso = !betweenNumber(Number(itemRelation?.mhi_oso_cd?.toString()?.length ?? 0), 0, 50);
    const isErrorDefaultSuryo = !betweenNumber(Number(itemRelation?.mhi_default_suryo?.toString()?.length ?? 0), 0, 11);

    return {
      isErrorAddHinmei1,
      isErrorAddHinmei2,
      isErrorProductPrice,
      isErrorMaintenancePrice,
      isErrorOso,
      isErrorDefaultSuryo,
    };
  };

  const initHeaderData = ({
    mstPrimarySales,
    mstSecondarySales,
    mstProduct,
    mstContractPeriod,
  }: {
    mstPrimarySales: PrimaryStore[];
    mstSecondarySales: SecondaryStore[];
    mstProduct: MstProduct[];
    mstContractPeriod: MstContractPeriod[];
  }) => {
    setPrimarySalesOption(
      mstPrimarySales.sort((a: PrimaryStore, b: PrimaryStore) => Number(a.mps_primary_cd) - Number(b.mps_primary_cd))
    );
    setSecondarySalesOptionRaw(
      mstSecondarySales.sort(
        (a: SecondaryStore, b: SecondaryStore) => Number(a.mss_secondary_cd) - Number(b.mss_secondary_cd)
      )
    );
    setProductOption(
      mstProduct.sort((a: MstProduct, b: MstProduct) => Number(a.mpr_product_cd) - Number(b.mpr_product_cd))
    );
    setContractPeriodOption(
      mstContractPeriod.sort((a: MstContractPeriod, b: MstContractPeriod) => Number(a.mcp_years) - Number(b.mcp_years))
    );
  };

  const initTableData = ({
    mstHinmei,
    mstPrimarySales,
    mstSecondarySales,
    mstProduct,
    mstHinInfo,
    mstContractPeriod,
  }: {
    mstHinmei: MstHinmei[];
    mstPrimarySales: PrimaryStore[];
    mstSecondarySales: SecondaryStore[];
    mstProduct: MstProduct[];
    mstHinInfo: MstHinInfor[];
    mstContractPeriod: MstContractPeriod[];
  }) => {
    let initHinInfoList: { [key: number]: MstRelation } = {};

    mstHinmei.forEach((hinmei) => {
      mstSecondarySales.forEach((secondarySales) => {
        const filterPrimarySales: PrimaryStore[] = mstPrimarySales.filter(
          (primarySales) => primarySales.mps_primary_cd === secondarySales.mss_primary_cd
        );
        mstProduct.forEach((product) => {
          for (let i = 0; i < mstContractPeriod.length; i++) {
            const contractPeriod = mstContractPeriod[i];
            const hinInfo: MstHinInfor[] = mstHinInfo.filter(
              (itemHinInfo: MstHinInfor) =>
                String(itemHinInfo.mhi_primary_cd) === String(secondarySales.mss_primary_cd) &&
                String(itemHinInfo.mhi_secondary_cd) === String(secondarySales.mss_secondary_cd) &&
                String(itemHinInfo.mhi_product_cd) === String(product.mpr_product_cd) &&
                String(itemHinInfo.mhi_hin_cd) === String(hinmei.mh_hin_cd) &&
                String(itemHinInfo.mhi_years) ===
                  (product.mpr_discount_type === DiscountType.MAINTAIN_PRICE
                    ? String(0)
                    : String(contractPeriod.mcp_years))
            );

            const item = {
              mhi_hin_cd: hinmei.mh_hin_cd,
              mh_hin_nm: hinmei.mh_hin_nm,
              mhi_primary_cd: secondarySales.mss_primary_cd,
              mps_primary_nm: filterPrimarySales[0]?.mps_primary_nm,
              mhi_secondary_cd: secondarySales.mss_secondary_cd,
              mss_secondary_nm: secondarySales.mss_secondary_nm,
              mhi_product_cd: product.mpr_product_cd,
              mpr_product_nm: product.mpr_product_nm,
              mhi_years:
                product.mpr_discount_type === DiscountType.MAINTAIN_PRICE ? 0 : Number(contractPeriod.mcp_years),
              mhi_add_hinmei1: hinInfo[0]?.mhi_add_hinmei1,
              mhi_add_hinmei2: hinInfo[0]?.mhi_add_hinmei2,
              mhi_product_price: hinInfo[0]?.mhi_product_price,
              mhi_maintenance_price: hinInfo[0]?.mhi_maintenance_price,
              mhi_available_kb: hinInfo[0]?.mhi_available_kb,
              mhi_oso_cd: hinInfo[0]?.mhi_oso_cd,
              mhi_default_suryo: hinInfo[0]?.mhi_default_suryo,
              recordState: RecordState.NONE,
              error: defaultErrorMstProductName,
              isBeginData: hinInfo.length > 0,
            };

            initHinInfoList = {
              ...initHinInfoList,
              ...{
                [`${hinmei.mh_hin_cd}${secondarySales.mss_primary_cd}${secondarySales.mss_secondary_cd}${product.mpr_product_cd}${contractPeriod.mcp_years}`]:
                  item,
              },
            };

            if (product.mpr_discount_type === DiscountType.MAINTAIN_PRICE) {
              // 保守料金の場合は契約年数は加味しない
              break;
            }
          }
        });
      });
    });
    setMstRelation(initHinInfoList);
    setRalationDisplayWithSort(initHinInfoList);
  };

  const loadInitData = async () => {
    // ヘッダー部の条件を取得
    const initDataList = await Promise.all([
      searchMstPrimarySales({ variables: { input: {} } }),
      searchMstSecondarySales({ variables: { input: {} } }),
      searchMstProduct({ variables: { input: {} } }),
      searchMstContractPeriod({ variables: { input: {} } }),
    ]);

    const primarySales = initDataList[0].data.getMstPrimarySales;
    const secondarySales = initDataList[1].data.getMstSecondarySales;
    const product = initDataList[2].data.getMstProduct;
    const contractPeriod = initDataList[3].data.getMstContractPeriod;

    initHeaderData({
      mstPrimarySales: primarySales,
      mstSecondarySales: secondarySales,
      mstProduct: product,
      mstContractPeriod: contractPeriod,
    });
  };

  useEffect(() => {
    loadInitData();
  }, []);

  return (
    <MainLayout>
      <div className="justify-center items-center">
        <div className="flex flex-col justify-center items-center">
          <p className="p-[20px]">品名情報紐づけ管理</p>
          <div className="flex w-4/5">
            <button
              onClick={onPressConfirmRegister}
              className="border-[#000000] border-[1px] p-[10px] mt-[25px] mb-[25px] text-center h-[50px] w-[100px] flex justify-center items-center"
            >
              <b>登録</b>
            </button>
          </div>
          <div className="flex w-4/5">{renderPullDown}</div>
          <div className="w-4/5">
            <table className="text-center border-collapse border-[3px] border-solid border-[#ddd] w-full">
              <tbody>
                <tr className="hover:opacity-80 even:bg-[#e2efd9]">{renderTableHeader()}</tr>
                {isHinmeiLoading ||
                isPStoreLoading ||
                isSStoreLoading ||
                isProductLoading ||
                isHinInfoLoading ||
                isContractPeriodLoading ? (
                  <tr className="hover:opacity-80 even:bg-[#e2efd9]">
                    <td
                      colSpan={header.length}
                      className="text-center animate-pulse p-[8px] border-[1px] border-solid border-[#fff]"
                    >
                      Loading...
                    </td>
                  </tr>
                ) : (
                  renderTableData
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HinInfoManage;
